import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'
import { ApiBaseProvider } from './api-base-provider'
import { V2GlobalHeader } from './v2-global-header'
import '../v2-theme.css'

// ─── Theme Context ────────────────────────────────────
type ThemeMode = 'light' | 'dark'

type ThemeContextValue = {
  mode: ThemeMode
  toggle: () => void
}

const THEME_KEY = 'wistor-v2-theme'

function loadTheme(): ThemeMode {
  try {
    const stored = localStorage.getItem(THEME_KEY)
    if (stored === 'dark' || stored === 'light') return stored
  } catch {}
  // Default to dark (matches our preview aesthetic)
  return 'dark'
}

const ThemeContext = createContext<ThemeContextValue>({ mode: 'dark', toggle: () => {} })

export function useV2Theme() {
  return useContext(ThemeContext)
}

// ─── Layout Component ─────────────────────────────────
export function V2Layout({ children }: { children: React.ReactNode }) {
  const [mode, setMode] = useState<ThemeMode>(loadTheme)

  const toggle = useCallback(() => {
    setMode(prev => {
      const next = prev === 'dark' ? 'light' : 'dark'
      try { localStorage.setItem(THEME_KEY, next) } catch {}
      return next
    })
  }, [])

  return (
    <ThemeContext.Provider value={{ mode, toggle }}>
      <ApiBaseProvider>
        <div className={`wistor-v2 ${mode === 'dark' ? 'v2-dark' : ''}`}>
          <V2GlobalHeader />
          <main>
            {children}
          </main>
        </div>
      </ApiBaseProvider>
    </ThemeContext.Provider>
  )
}
